import React from 'react';

import { ARTICLE_TYPES } from '@api/articles/constants';
import { ROLE } from '@api/users/constants';

import useUserRole from './useUserRole';

const useArticleTypes = () => {
  const role = useUserRole();

  const types = React.useMemo(() => {
    if (role === ROLE.EDITOR) {
      return ARTICLE_TYPES;
    }
    return ARTICLE_TYPES.filter(
      ({ visibleFor }) => !visibleFor || visibleFor.length === 0 || visibleFor.includes(role),
    );
  }, [role]);

  return types;
};

export default useArticleTypes;
